const listingCriteriaUtils = {
  getCriteriaByType<T extends { type: string }>(criteriaList: Array<T>, criteriaType: string) {
    const foundIndex = criteriaList?.findIndex((obj) => obj.type === criteriaType);
    const targetCriteria = criteriaList?.[foundIndex] || null;

    return targetCriteria;
  },
  getNegotiableDisplay(value: boolean | null): string | null {
    return value === null ? null : value ? 'negotiable' : 'non-negotiable';
  },
};
export default listingCriteriaUtils;
